module.exports = __webpack_public_path__ + "statics/img/earthwork-1.596e5078.png";